import React from 'react';
import { useDispatch } from 'react-redux';
import { updateMeetingRoom, resetMeetingRoomForm, deleteMeetingRoom } from '../../../../actions/meetingRoom';
import { removeMRInEntityList } from '../../../../actions/organisation.js';
import { updateShowDeleteMeetingRoomModal } from '../../../../actions/modal';

export default function RightPanelDelete(props) {
  const dispatch = useDispatch();

  const deletecurrentMeetingRoom = () => {
    let cb = (result) => {
      let isOnEntityListingPage = window.getState().organisationsReducer.isOnEntityListingPage;
      // If it's on entity admin Page
      if (!!isOnEntityListingPage) {
        let lastCb = (result) => {
          dispatch(updateShowDeleteMeetingRoomModal(!result));
          resetForm();
          props.cbAfterDeletion();
        };
        dispatch(removeMRInEntityList(props.meetingRoomForm.id, props.meetingRoomForm.organisationNetworkId, lastCb));
      } else {
        if (!!result) {
          dispatch(updateShowDeleteMeetingRoomModal(!result));
          resetForm();
        }
      }
    };
    dispatch(deleteMeetingRoom(props.meetingRoomForm, cb));
  };

  const cancelCreateMeetingRoom = () => {
    dispatch(updateShowDeleteMeetingRoomModal(false));
    resetForm();
  };

  const resetForm = () => {
    dispatch(resetMeetingRoomForm());
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width mrlnull mrbnull';
  return (
    <div className="ui actions mrbs max-width">
      <button
        type="button"
        onClick={deletecurrentMeetingRoom}
        className={props.meetingRoomForm && props.meetingRoomForm.fetching ? saveClasses + ' loading' : saveClasses}
      >
        {APP.LANGUAGE.Yes}
        <i className="checkmark icon " />
      </button>
      <button
        onClick={cancelCreateMeetingRoom}
        type="button"
        className="ui cancel labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
      >
        <i className="remove  icon" />
        {APP.LANGUAGE.No}
      </button>
    </div>
  );
}
